module.exports = __webpack_public_path__ + "static/media/textediter_link.1312ee0b.svg";